import './Resume.css';
import { useEffect, useState } from 'react';
import HackerAvatar from '../components/HackerAvatar';
import avatarSrc from '../assets/quentinyuan.jpg';

function Resume({ onBack }) {
  const [showToTop, setShowToTop] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setShowToTop(window.scrollY > 400);
    };

    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="resume-page">
      <div className="resume-page__header">
        <button type="button" className="resume-page__back" onClick={onBack}>
          返回
        </button>
      </div>

      <button
        type="button"
        className={`resume-page__to-top ${showToTop ? 'resume-page__to-top--visible' : ''}`}
        onClick={handleToTop}
        aria-label="返回顶部"
        title="返回顶部"
      >
        ↑
      </button>

      <div className="resume-page__content">
        <section className="resume-section">
          <h2 className="resume-section__title">基本信息</h2>
          <div className="resume-card resume-card--info">
            <div className="resume-info-layout">
              <div className="resume-avatar-wrapper">
                <HackerAvatar src={avatarSrc} alt="袁群杰" />
              </div>
              <div className="resume-table resume-table--info">
                <div className="resume-table__row">
                  <div className="resume-table__cell resume-table__cell--k">姓名</div>
                  <div className="resume-table__cell resume-table__cell--v">袁群杰</div>
                  <div className="resume-table__cell resume-table__cell--k">年龄</div>
                  <div className="resume-table__cell resume-table__cell--v">26 岁</div>
                </div>
                <div className="resume-table__row">
                  <div className="resume-table__cell resume-table__cell--k">手机号</div>
                  <div className="resume-table__cell resume-table__cell--v">15192896912</div>
                  <div className="resume-table__cell resume-table__cell--k">邮箱</div>
                  <div className="resume-table__cell resume-table__cell--v">yuanqunjie@yeah.net</div>
                </div>
                <div className="resume-table__row">
                  <div className="resume-table__cell resume-table__cell--k">学历</div>
                  <div className="resume-table__cell resume-table__cell--v">本科（山东协和学院2022.09-2024.06）</div>
                  <div className="resume-table__cell resume-table__cell--k">专业</div>
                  <div className="resume-table__cell resume-table__cell--v">物联网工程</div>
                </div>
                <div className="resume-table__row">
                  <div className="resume-table__cell resume-table__cell--k">工作年限</div>
                  <div className="resume-table__cell resume-table__cell--v">3 年</div>
                  <div className="resume-table__cell resume-table__cell--k">应聘岗位</div>
                  <div className="resume-table__cell resume-table__cell--v">Java 开发工程师</div>
                </div>
                <div className="resume-table__row">
                  <div className="resume-table__cell resume-table__cell--k">GitHub</div>
                  <div className="resume-table__cell resume-table__cell--v resume-table__cell--span3 resume-github-cell">
                    <a
                      href="https://github.com/yuanqunjie"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="resume-github-link"
                    >
                      <svg className="resume-github-icon" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true">
                        <path d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.013 8.013 0 0016 8c0-4.42-3.58-8-8-8z" />
                      </svg>
                      <span className="resume-github-text">github.com/yuanqunjie</span>
                      <span className="resume-github-arrow">→</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="resume-table__row resume-table__row--advantage">
              <div className="resume-table__cell resume-table__cell--k">核心优势</div>
              <div className="resume-table__cell resume-table__cell--v resume-table__cell--span3">
                3 年Java 开发经验，熟练掌握 SpringBoot/SpringCloud 微服务架构，具备 Linux 环境部署、多数据库开发能力，熟悉物联网协议（MQTT）与消息队列（RocketMQ），具备独立完成前后端一体化开发的能力
              </div>
            </div>
          </div>
        </section>

        <section className="resume-section">
          <h2 className="resume-section__title">专业技能</h2>
          <div className="resume-card resume-paragraph">
            熟练掌握 Java 开发，精通 SpringBoot/SpringCloud 微服务框架，具备 Linux 环境下项目部署与运维能力；精通 MySQL 数据库优化、Redis 缓存设计，熟练使用 RocketMQ 实现消息队列功能；掌握 Vue/Element UI 前端开发、Git 版本控制，熟悉 Postman/Apifox 接口调试，具备多数据库（SQL Server / 达梦）开发经验。
          </div>
        </section>

        <section className="resume-section">
          <h3 className="resume-section__subtitle">核心技术栈</h3>
          <div className="resume-card">
            <div className="resume-skill-table">
              <div className="resume-skill-table__head">
                <div>分类</div>
                <div>技能项</div>
                <div>熟练度 & 核心应用场景</div>
              </div>

              <div className="resume-skill-table__row">
                <div>核心编程语言</div>
                <div>Java、C#</div>
                <div>Java（熟练）：主导 SpringBoot/SpringCloud 微服务项目开发； C#（掌握）：.Net 项目开发</div>
              </div>

              <div className="resume-skill-table__row">
                <div>开发框架</div>
                <div>SpringBoot、SpringCloud、Vue、.Net</div>
                <div>SpringBoot/SpringCloud（熟练）：搭建分布式微服务架构； Vue/Element UI（熟练）：前端页面开发； .Net（掌握）：Windows桌面应用开发</div>
              </div>

              <div className="resume-skill-table__row">
                <div>中间件 / 服务器</div>
                <div>MQTT、RocketMQ、RabbitMQ、Canal、Tomcat、AndServer、Linux、Docker</div>
                <div>Linux（熟练）：CentOS/Ubuntu 环境搭建、项目打包部署； RocketMQ/Tomcat（熟练）：消息队列应用、服务部署； MQTT/Canal（了解）：物联网 / 数据同步场景</div>
              </div>

              <div className="resume-skill-table__row">
                <div>数据库 / 缓存</div>
                <div>MySQL、Mybatis、SQL Server、Redis、Sqlite、达梦数据库</div>
                <div>MySQL/Redis（熟练）：SQL 索引优化、缓存解决方案； SQL Server / 达梦 / Sqlite（掌握）：项目所用数据库</div>
              </div>

              <div className="resume-skill-table__row">
                <div>全栈 / 移动端拓展</div>
                <div>HTML、JavaScript、CSS、Echarts、Element UI、Android、微信小程序</div>
                <div>HTML/CSS/JS（掌握）：前端页面开发与数据可视化（Echarts）； Android / 小程序（掌握）：移动端应用开发</div>
              </div>
            </div>
          </div>
        </section>

        <section className="resume-section">
          <h3 className="resume-section__subtitle">开发工具与工程化能力</h3>
          <div className="resume-card">
            <div className="resume-skill-table">
              <div className="resume-skill-table__head">
                <div>分类</div>
                <div>技能项</div>
                <div>高频使用场景</div>
              </div>

              <div className="resume-skill-table__row">
                <div>代码编辑器</div>
                <div>IDEA、Visual Studio、VS Code、Android Studio、HBuilderX、PyCharm</div>
                <div>主力：IDEA（Java/SpringCloud 开发）、Visual Studio（C#/.Net）； AI 辅助：Cursor、Trae、Windsurf、Kiro</div>
              </div>

              <div className="resume-skill-table__row">
                <div>数据库管理工具</div>
                <div>Navicat、DataGrip、SQLite Studio、RedisDesktopManager、达梦管理工具</div>
                <div>高频：DataGrip（MySQL/Redis 管理）、Navicat（多数据库适配）； 掌握：达梦管理工具</div>
              </div>

              <div className="resume-skill-table__row">
                <div>版本控制工具</div>
                <div>TortoiseGit、TortoiseSVN</div>
                <div>熟练使用 Git/SVN 进行代码分支管理、团队协作、版本回滚</div>
              </div>

              <div className="resume-skill-table__row">
                <div>接口调试工具</div>
                <div>Postman、Apifox</div>
                <div>日常：Apifox（接口测试 + 文档生成）； 辅助：Postman（跨环境接口调试）</div>
              </div>
            </div>
          </div>
        </section>

        <section className="resume-section">
          <h2 className="resume-section__title">项目经历</h2>
          <a
            href="http://blog.quentinyuan.online/?post=2"
            target="_blank"
            rel="noopener noreferrer"
            className="resume-project-link"
          >
            <div className="resume-project-card">
              <div className="resume-project-card__glow" />
              <div className="resume-project-card__content">
                <div className="resume-project-card__icon">📂</div>
                <div className="resume-project-card__info">
                  <span className="resume-project-card__title">个人项目经历</span>
                  <span className="resume-project-card__desc">点击查看完整项目文档与案例详情</span>
                </div>
                <span className="resume-project-card__arrow">→</span>
              </div>
            </div>
          </a>
        </section>

        <section className="resume-section">
          <h2 className="resume-section__title">技能资质</h2>
          <div className="resume-card resume-paragraph">
            华为云计算（HCIA）、华为鲲鹏开发（HCIP）、全国计算机等级考试-数据库（三级）、人工智能训练师（四级）
          </div>
        </section>
      </div>
    </div>
  );
}

export default Resume;
